import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import CargoCredito from './CargoCredito';
import ACCESS from '../../../ACCESS.js';

class CargosCreditos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'cargo-credito/filter', deleteUrl: 'cargo-credito/delete', deleteField: 'cc_nombre', modUrl: '/Catalogo/Cargo' },
      TableOp.Table('Cargos/Creditos', [
        { label: 'Clave', id: 'cargo_credito' },
        { label: 'Descripcion', id: 'cc_nombre' },
        { label: 'Tipo', id: 'cc_tipo' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_CARGOS_CREDITOS.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_CARGOS_CREDITOS.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <CargoCredito  onSave={() => {this.table()}}></CargoCredito>
          }
          {
             
          <this.TableRender  />
          }
        </div>
      </div>
    )
  }
}

export default withRouter(CargosCreditos)